import {
	SERVICE_REQUEST,
	INCIDENTS,
	PROBLEMS,
	CHANGES,
	POST_INCIDENT_REVIEWS,
	DEVELOPER_ESCALATION,
	SHORT_FORM_SERVICE_REQUEST,
	SHORT_FORM_INCIDENTS,
	SHORT_FORM_PROBLEMS,
	SHORT_FORM_CHANGES,
	SHORT_FORM_POST_INCIDENT_REVIEWS,
	SHORT_FORM_DEVELOPER_ESCALATION,
} from '../../common/constants.tsx';
import type { WorkCategoryShortForm, WorkCategoryApiResource } from '../../common/types.tsx';

const longToShortConversionMap: Record<WorkCategoryApiResource, WorkCategoryShortForm> = {
	[CHANGES]: SHORT_FORM_CHANGES,
	[INCIDENTS]: SHORT_FORM_INCIDENTS,
	[PROBLEMS]: SHORT_FORM_PROBLEMS,
	[SERVICE_REQUEST]: SHORT_FORM_SERVICE_REQUEST,
	[POST_INCIDENT_REVIEWS]: SHORT_FORM_POST_INCIDENT_REVIEWS,
	[DEVELOPER_ESCALATION]: SHORT_FORM_DEVELOPER_ESCALATION,
};

function isLongForm(
	workCategoryKey: string,
): workCategoryKey is keyof typeof longToShortConversionMap {
	return !!workCategoryKey && workCategoryKey in longToShortConversionMap;
}

export const toShortFormItsmPractice = (workCategoryKey: string): WorkCategoryShortForm | null => {
	if (isLongForm(workCategoryKey)) return longToShortConversionMap[workCategoryKey];
	return null;
};
